import { clsx } from 'clsx'
import { type ComponentPropsWithRef, type ReactElement } from 'react'

import { IconSprites } from '@constants/enums/sprites'

import { Icon, type IconProps } from '@components/ui-core/icon/icon'
import { Row } from '@components/ui-core/row/row'

import { HeroCard } from '@custom/components/hero-card/hero-card'
import { HomepageText } from '@custom/pages/homepage/text/homepage-text'

import styles from './tool.module.css'

type ToolVariant = 'scheduler' | 'proofreader' | 'grammarly'

const variantToIconMap: Record<ToolVariant, IconProps['variant']> = {
  scheduler: IconSprites.Sparkle,
  proofreader: IconSprites.ReaderReactions,
  grammarly: IconSprites.GrammarlyLogo,
}

interface ToolProps extends ComponentPropsWithRef<'div'> {
  variant: ToolVariant
  text: string
}

export function Tool(props: ToolProps): ReactElement {
  const { className, variant, text, ...rest } = props

  return (
    <HeroCard
      className={clsx(styles.tool, variant === 'scheduler' && styles.isScheduler, className)}
      {...rest}
    >
      <Row crossAxisAlignment="center" gap="2x" wrap={variant === 'scheduler'}>
        <Icon variant={variantToIconMap[variant]} />
        <HomepageText variant="heroCard">{text}</HomepageText>
      </Row>
    </HeroCard>
  )
}
